import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MessageSquareText, Settings2 } from "lucide-react";
import { ManageRepliesDialog } from "@/components/support/ManageRepliesDialog";

export function QuickReplies({ customerName, onPick }) {
  const [open, setOpen] = useState(false);
  const [manage, setManage] = useState(false);
  const [replies, setReplies] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/support/replies");
      setReplies(data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };
  useEffect(() => { if (open || manage) load(); }, [open, manage]);

  const pick = (r) => {
    onPick(r.text.replaceAll("{الاسم}", customerName || ""));
    setOpen(false);
  };
  const shown = replies.filter((r) => !q.trim() || (r.title + r.text).includes(q.trim()));

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" size="icon" variant="ghost" className="rounded-full shrink-0" title="ردود جاهزة" data-testid="quick-replies-btn">
            <MessageSquareText className="w-4 h-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" side="top" className="w-80 p-0" dir="rtl" data-testid="quick-replies-popover">
          <div className="p-2 border-b border-border">
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث في الردود الجاهزة" className="h-8 text-sm" data-testid="quick-replies-search" />
          </div>
          <div className="max-h-64 overflow-y-auto">
            {shown.length === 0 ? (
              <div className="p-4 text-center text-xs text-muted-foreground" data-testid="quick-replies-empty">لا توجد ردود</div>
            ) : shown.map((r) => (
              <button key={r.id} type="button" onClick={() => pick(r)} data-testid={`quick-reply-${r.id}`}
                className="w-full text-start px-3 py-2 hover:bg-muted/60 transition-colors">
                <div className="text-sm font-semibold">{r.title}</div>
                <div className="text-xs text-muted-foreground line-clamp-2">{r.text}</div>
              </button>
            ))}
          </div>
          <button type="button" onClick={() => { setOpen(false); setManage(true); }} data-testid="manage-replies-btn"
            className="w-full flex items-center justify-center gap-1.5 text-xs text-primary py-2 border-t border-border hover:bg-muted/60">
            <Settings2 className="w-3.5 h-3.5" /> إدارة الردود الجاهزة
          </button>
        </PopoverContent>
      </Popover>
      <ManageRepliesDialog open={manage} onOpenChange={setManage} replies={replies} reload={load} />
    </>
  );
}
